require('./bootstrap')
require('bootstrap')
window.suggestions = require('suggestions-jquery')

$(document).ready(() => {
  const $selectCityModal = $('#selectCityModal')
  $selectCityModal.on('shown.bs.modal', () => {
    const $modalBody = $selectCityModal.find('.modal-body')
    if ($modalBody.find('.fa-spinner').length === 0) {
      $selectCityModal.find('input#city_search').val('').trigger('keyup')
      return
    }

    axios.post('/cities/get').then((response) => {
      let data = ''
      if (response.status === 200 && (response.data.status || '') === 'success') {
        data = response.data.html
      } else {
        toastr.error('Не удалось получить список городов')
      }
      $selectCityModal.find('.modal-body').html(data)
      $selectCityModal.find('input#city_search').focus()
    }).catch((response) => {
      toastr.error('Не удалось получить список городов')
      console.log(response)
    })
  })

  $selectCityModal.on('keyup', '#city_search', function () {
    $selectCityModal.find('.cities .cities-first-letter, .cities .city').addClass('d-block').removeClass('d-none') // show
    const val = $(this).val().toLowerCase()
    if (val !== '') {
      $selectCityModal.find('.cities .cities-first-letter').removeClass('d-block').addClass('d-none') // hide
      $selectCityModal.find('.cities a.city').each(function () {
        const $city = $(this)
        if ($city.text().toLowerCase().indexOf(val) !== 0) {
          $city.removeClass('d-block').addClass('d-none') // hide
        }
      })
    }
  })

  $('.dadata-fio').each(function () {
    $(this).suggestions({
      type: 'NAME',
      token: process.env.MIX_DADATA_TOKEN,
    })
  })

  $('.dadata-email').each(function () {
    $(this).suggestions({
      type: 'EMAIL',
      token: process.env.MIX_DADATA_TOKEN,
    })
  })

  $('.dadata-inn').each(function () {
    const $this = $(this)
    $this.suggestions({
      type: 'PARTY',
      token: process.env.MIX_DADATA_TOKEN,
      params: {
        status:  ["ACTIVE"]
      },
      onSelect: ({data}) => {
        if (!data) {
          return
        }

        $this.val(data.inn)
      }
    })
  })
})